import { ProvisioningStatus } from '@/types/responses/getProvisioningStatuses'
import { ProvisioningCategory } from '@/types/requests/getProvisioningStatuses'

export const PROVISIONING_CATEGORIES: ProvisioningCategory[] = ['not_executed', 'running', 'failed', 'done']

// gps_tracker_provisioning_statuses に行が無いデバイスは未実行
// topic_pending は config と証明書が終わってトピックだけ待っている状態なので進行中にする
// ワークフロー自体は終わっているので、操作できるかは isProvisioningRunning で別に見る
// running と done 以外はすべて失敗
export function getProvisioningCategory (provisioningStatus: ProvisioningStatus | null): ProvisioningCategory {
  if (provisioningStatus === null) {
    return 'not_executed'
  }
  if (provisioningStatus.status === 'running' || provisioningStatus.status === 'topic_pending') {
    return 'running'
  }
  if (provisioningStatus.status === 'done') {
    return 'done'
  }
  return 'failed'
}

// 実際に動いていて操作できないのは running だけ。topic_pending は再実行できる
export function isProvisioningRunning (provisioningStatus: ProvisioningStatus | null): boolean {
  return provisioningStatus?.status === 'running'
}
